import React from 'react';
import { ClipLoader } from 'react-spinners';
import '../../../assets/css/loader.css';

const Loader = () => {
  return (
    <div className="loader-container">
      <ClipLoader size={50} color="#916008" />
    </div>
  );
};

export default Loader;
